
import { defineComponent } from 'vue'
import { FilterOperator } from 'primevue/api'
import { filterDefault } from '@/helpers/commons/filterHelper'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import Message from 'primevue/message'
import documentBrowserTableDescriptor from './DocumentBrowserTableDescriptor.json'
import { getCorrectRolesForExecution } from '../../../../helpers/commons/roleHelper'

export default defineComponent({
    name: 'document-browser-table',
    components: { Column, DataTable, Message },
    props: { propDocuments: { type: Array }, searchMode: { type: Boolean } },
    emits: ['itemSelected', 'selected'],
    data() {
        return {
            documentBrowserTableDescriptor,
            documents: [] as any[],
            filters: {
                global: [filterDefault],
                typeCode: {
                    operator: FilterOperator.AND,
                    constraints: [filterDefault]
                },
                name: {
                    operator: FilterOperator.AND,
                    constraints: [filterDefault]
                },
                label: {
                    operator: FilterOperator.AND,
                    constraints: [filterDefault]
                },
                creationUser: {
                    operator: FilterOperator.AND,
                    constraints: [filterDefault]
                },
                stateCodeStr: {
                    operator: FilterOperator.AND,
                    constraints: [filterDefault]
                }
            } as any,
            user: null as any,
            first: 0
        }
    },
    watch: {
        propDocuments() {
            this.loadDocuments()
            this.first = 0
        }
    },
    computed: {
        isAdmin(): boolean {
            return this.user?.functionalities.includes('DocumentManagement') || this.user?.isSuperadmin
        }
    },
    created() {
        this.loadDocuments()
        this.first = 0
        this.user = (this.$store.state as any).user
    },
    methods: {
        loadDocuments() {
            this.documents = this.propDocuments?.map((el: any) => {
                if (el.field === 'status') el.style = documentBrowserTableDescriptor.table.smallmessage
                return { ...el, stateCodeStr: this.getTranslatedStatus(el.stateCodeStr) }
            }) as any[]
        },
        getTranslatedStatus(status: string) {
            return status ? this.$t(documentBrowserTableDescriptor.status[status] ?? '') : ''
        },
        executeDocument(document: any) {
            getCorrectRolesForExecution(document).then(() => {
                this.$emit('itemSelected', { item: document, mode: 'execute' })
            })
        },
        getTranslatedValue(value: string, fieldType: string) {
            if (fieldType !== 'name' && fieldType !== 'label') return value
            return (this as any).$internationalization(value)
        }
    }
})
